export const styles = {
    description: {
        color: "greyscale.700"
    },
    border: {
        borderTop: ({ palette }) => `1px solid ${palette.greyscale[200]}`
    }
};
